import { CalendarDotsIcon } from '@phosphor-icons/react';
import { DatePicker as AntdDatePicker } from 'antd';
import type { ComponentProps } from 'react';

import styles from './date-picker.module.scss';

const { RangePicker: AntdRangePicker } = AntdDatePicker;

export type DateRangePickerProps = Omit<ComponentProps<typeof AntdRangePicker>, 'suffixIcon'>;

export function DateRangePicker({
  className,
  classNames,
  format,
  placeholder,
  ...rest
}: DateRangePickerProps) {
  return (
    <AntdRangePicker
      {...rest}
      format={format ?? 'MM/DD/YYYY'}
      placeholder={placeholder ?? ['mm/dd/yyyy', 'mm/dd/yyyy']}
      suffixIcon={<CalendarDotsIcon size={14} aria-hidden />}
      className={[styles.picker, className].filter(Boolean).join(' ')}
      classNames={{
        ...classNames,
        popup: {
          root: [styles.popup, (classNames as { popup?: { root?: string } })?.popup?.root]
            .filter(Boolean)
            .join(' '),
        },
      }}
    />
  );
}
